import { render, staticRenderFns } from "./ModalUploadDocument.vue?vue&type=template&id=5c7b9c8b"
import script from "./ModalUploadDocument.vue?vue&type=script&lang=js"
export * from "./ModalUploadDocument.vue?vue&type=script&lang=js"
import style0 from "./ModalUploadDocument.vue?vue&type=style&index=0&id=5c7b9c8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports